var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user_list_page" },
    [
      _vm.isDeviceModelsLoaded
        ? _c("business-group", {
            ref: "businessGroup",
            attrs: {
              tableConfig: {
                ..._vm.tableConfig,
                rowSelection: _vm.rowSelection,
              },
              formConfig: { ..._vm.formConfig },
              formValues: _vm.dynamicFormValues,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "tableAction",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center",
                              },
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "250px" },
                                  attrs: {
                                    placeholder: "请选择设备型号",
                                    allowClear: "",
                                  },
                                  on: { change: _vm.handleDeviceModelChange },
                                  model: {
                                    value: _vm.selectedDeviceModel,
                                    callback: function ($$v) {
                                      _vm.selectedDeviceModel = $$v
                                    },
                                    expression: "selectedDeviceModel",
                                  },
                                },
                                _vm._l(_vm.deviceModels, function (model) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: model.deviceModel,
                                      attrs: { value: model.deviceModel },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "80px",
                                          },
                                        },
                                        [_vm._v(_vm._s(model.modelName))]
                                      ),
                                      _c("span", [
                                        _vm._v(_vm._s(model.deviceDescription)),
                                      ]),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    type: "primary",
                                    disabled: _vm.selectedRowKeys.length === 0,
                                  },
                                  on: { click: _vm.handleBatchCopy },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "copy" } }),
                                  _vm._v(
                                    " 一键复制 (" +
                                      _vm._s(_vm.selectedRowKeys.length) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      _vm.selectedRowKeys.length === 0 ||
                                      !_vm.canBatchShelf,
                                  },
                                  on: { click: _vm.handleBatchShelf },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "arrow-up" } }),
                                  _vm._v(
                                    " 一键上架 (" +
                                      _vm._s(_vm.selectedRowKeys.length) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      _vm.selectedRowKeys.length === 0 ||
                                      !_vm.canBatchConfirm,
                                  },
                                  on: { click: _vm.handleBatchConfirm },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "check" } }),
                                  _vm._v(
                                    " 一键确认 (" +
                                      _vm._s(_vm.selectedRowKeys.length) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      _vm.selectedRowKeys.length === 0 ||
                                      !_vm.canBatchUnShelf,
                                  },
                                  on: { click: _vm.handleBatchUnShelf },
                                },
                                [
                                  _c("a-icon", {
                                    attrs: { type: "arrow-down" },
                                  }),
                                  _vm._v(
                                    " 一键下架 (" +
                                      _vm._s(_vm.selectedRowKeys.length) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      _vm.selectedRowKeys.length === 0 ||
                                      !_vm.canBatchDelete,
                                  },
                                  on: { click: _vm.handleBatchDelete },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "delete" } }),
                                  _vm._v(
                                    " 一键删除 (" +
                                      _vm._s(_vm.selectedRowKeys.length) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      _vm.selectedRowKeys.length === 0 ||
                                      !_vm.canBatchExport,
                                  },
                                  on: { click: _vm.handleExportExcel },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "download" } }),
                                  _vm._v(
                                    " Excel导出 (" +
                                      _vm._s(_vm.selectedRowKeys.length) +
                                      ") "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleRefreshList },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "reload" } }),
                                  _vm._v(" 刷新 "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "a-upload",
                                {
                                  attrs: {
                                    beforeUpload: _vm.handleImportExcel,
                                    showUploadList: false,
                                    accept: ".xlsx,.xls",
                                  },
                                },
                                [
                                  _c(
                                    "a-button",
                                    { attrs: { type: "primary" } },
                                    [
                                      _c("a-icon", {
                                        attrs: { type: "upload" },
                                      }),
                                      _vm._v(" Excel导入 "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "formSlot",
                  fn: function () {
                    return [
                      _c(
                        "a-form-item",
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["effectName"],
                                expression: "['effectName']",
                              },
                            ],
                            staticStyle: {
                              width: "200px",
                              "margin-right": "10px",
                              "vertical-align": "middle",
                            },
                            attrs: { placeholder: "请输入场景名称" },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["effectType"],
                                  expression: "['effectType']",
                                },
                              ],
                              staticStyle: {
                                width: "200px",
                                "margin-right": "10px",
                                "vertical-align": "middle",
                              },
                              attrs: {
                                placeholder: "请选择场景所属类别",
                                allowClear: "",
                              },
                            },
                            _vm._l(_vm.effectTypeList, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.effectType,
                                  attrs: { value: item.effectType },
                                },
                                [_vm._v(" " + _vm._s(item.effectType) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["sceneVersion"],
                                  expression: "['sceneVersion']",
                                },
                              ],
                              staticStyle: {
                                width: "200px",
                                "margin-right": "10px",
                                "vertical-align": "middle",
                              },
                              attrs: {
                                placeholder: "请选择场景版本",
                                allowClear: "",
                              },
                            },
                            _vm._l(_vm.sceneVersionList, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.version,
                                  attrs: { value: item.version },
                                },
                                [_vm._v(" Ver" + _vm._s(item.version) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["effectVersion"],
                                  expression: "['effectVersion']",
                                },
                              ],
                              staticStyle: {
                                width: "200px",
                                "margin-right": "10px",
                                "vertical-align": "middle",
                              },
                              attrs: {
                                placeholder: "请选择光效应用版本",
                                allowClear: "",
                              },
                            },
                            _vm._l(_vm.effectVersionList, function (item) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.version,
                                  attrs: { value: item.version },
                                },
                                [_vm._v(" V" + _vm._s(item.version) + " ")]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        [
                          _c(
                            "a-select",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["status"],
                                  expression: "['status']",
                                },
                              ],
                              staticStyle: {
                                width: "200px",
                                "margin-right": "10px",
                                "vertical-align": "middle",
                              },
                              attrs: {
                                placeholder: "请选择状态",
                                allowClear: "",
                              },
                            },
                            [
                              _c("a-select-option", { attrs: { value: "0" } }, [
                                _vm._v("未上架"),
                              ]),
                              _c("a-select-option", { attrs: { value: "1" } }, [
                                _vm._v("已上架"),
                              ]),
                              _c("a-select-option", { attrs: { value: "2" } }, [
                                _vm._v("已确认"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "status",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            ["未上架", "已上架", "已确认"][record.status] ||
                              record.status
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "createTime",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dataFormatStr(
                              record.createTime,
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "updateTime",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dataFormatStr(
                              record.updateTime,
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "effectOrder",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            ["", "标准", "慢", "快"][record.effectOrder] ||
                              record.effectOrder
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "sceneVersion",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            record.sceneVersion
                              ? `Ver${record.sceneVersion}`
                              : record.sceneVersion
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "effectVersion",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            record.effectVersion
                              ? `V${record.effectVersion}`
                              : record.effectVersion
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "icon",
                  fn: function (record) {
                    return [
                      _c("img", { attrs: { width: "30", src: record.icon } }),
                    ]
                  },
                },
                {
                  key: "selectedIcon",
                  fn: function (record) {
                    return [
                      _c("img", {
                        attrs: { width: "30", src: record.selectedIcon },
                      }),
                    ]
                  },
                },
                {
                  key: "creator",
                  fn: function (record) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            record.creator === 0 ? "admin" : record.creator
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "drag",
                  fn: function (record) {
                    return [
                      _c(
                        "span",
                        { staticClass: "drag-handle" },
                        [_c("a-icon", { attrs: { type: "drag" } })],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "action",
                  fn: function (record) {
                    return [
                      _c(
                        "a-space",
                        [
                          record.status === 0
                            ? [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: { click: () => _vm.batchShelf(record) },
                                  },
                                  [_vm._v("上架")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: {
                                      click: () => _vm.showUpdateForm(record),
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: { click: () => _vm.batchCopy(record) },
                                  },
                                  [_vm._v("复制")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: { click: () => _vm.deleted(record) },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            : record.status === 1
                            ? [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: {
                                      click: () => _vm.batchConfirm(record),
                                    },
                                  },
                                  [_vm._v("确认")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: { click: () => _vm.batchCopy(record) },
                                  },
                                  [_vm._v("复制")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: {
                                      click: () => _vm.batchUnShelf(record),
                                    },
                                  },
                                  [_vm._v("下架")]
                                ),
                              ]
                            : record.status === 2
                            ? [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: { click: () => _vm.batchCopy(record) },
                                  },
                                  [_vm._v("复制")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: {
                                      click: () => _vm.batchUnShelf(record),
                                    },
                                  },
                                  [_vm._v("下架")]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2046984973
            ),
          })
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            title:
              _vm.copyRecords.length > 1
                ? `批量复制 (${_vm.copyRecords.length}条)`
                : "复制场景特效",
            visible: _vm.copyModalVisible,
            confirmLoading: _vm.copyFormLoading,
            width: "500px",
          },
          on: { ok: _vm.handleCopySubmit, cancel: _vm.handleCopyCancel },
        },
        [
          _c(
            "a-form",
            { attrs: { layout: "vertical" } },
            [
              _c(
                "a-form-item",
                { attrs: { label: "场景版本" } },
                [
                  _c("a-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请输入场景版本（格式：x.y）",
                      prefix: "Ver",
                    },
                    model: {
                      value: _vm.copySceneVersion,
                      callback: function ($$v) {
                        _vm.copySceneVersion = $$v
                      },
                      expression: "copySceneVersion",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                { attrs: { label: "光效应用版本" } },
                [
                  _c("a-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请输入光效应用版本（格式：x.y）",
                      prefix: "V",
                    },
                    model: {
                      value: _vm.copyEffectVersion,
                      callback: function ($$v) {
                        _vm.copyEffectVersion = $$v
                      },
                      expression: "copyEffectVersion",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "编辑场景特效",
            destroyOnClose: "",
            visible: _vm.updateVisible,
            maskClosable: false,
            width: "500px",
          },
          on: { ok: _vm.update, cancel: () => (_vm.updateVisible = false) },
        },
        [
          _c(
            "a-form-model",
            {
              attrs: {
                modal: _vm.updateFrom,
                layout: "vertical",
                "label-col": _vm.labelCol,
                "wrapper-col": _vm.wrapperCol,
              },
            },
            [
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "id:" },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "id", showCount: "", maxlength: 64 },
                    model: {
                      value: _vm.updateFrom.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "id", $$v)
                      },
                      expression: "updateFrom.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "设备名称:" },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入设备名称", disabled: "" },
                    model: {
                      value: _vm.updateFrom.modelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "modelName", $$v)
                      },
                      expression: "updateFrom.modelName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "设备类型:" },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入设备类型", disabled: "" },
                    model: {
                      value: _vm.updateFrom.deviceType,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "deviceType", $$v)
                      },
                      expression: "updateFrom.deviceType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "设备型号:" },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入设备型号", disabled: "" },
                    model: {
                      value: _vm.updateFrom.deviceModel,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "deviceModel", $$v)
                      },
                      expression: "updateFrom.deviceModel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "已导入场景效果表:" },
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "已导入场景效果表", disabled: "" },
                      model: {
                        value: _vm.updateFrom.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.updateFrom, "status", $$v)
                        },
                        expression: "updateFrom.status",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "0" } }, [
                        _vm._v("否"),
                      ]),
                      _c("a-select-option", { attrs: { value: "1" } }, [
                        _vm._v("是"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "创建人:" },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "创建人", disabled: "" },
                    model: {
                      value: _vm.updateFrom.creator,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "creator", $$v)
                      },
                      expression: "updateFrom.creator",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "创建时间:" },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "创建时间", disabled: "" },
                    model: {
                      value: _vm.updateFrom.createTime,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "createTime", $$v)
                      },
                      expression: "updateFrom.createTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "场景名称:" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择场景名称", allowClear: "" },
                      model: {
                        value: _vm.updateFrom.effectName,
                        callback: function ($$v) {
                          _vm.$set(_vm.updateFrom, "effectName", $$v)
                        },
                        expression: "updateFrom.effectName",
                      },
                    },
                    _vm._l(_vm.updateEffectNameList, function (item) {
                      return _c(
                        "a-select-option",
                        {
                          key: item.chineseName,
                          attrs: { value: item.chineseName },
                        },
                        [_vm._v(" " + _vm._s(item.chineseName) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "所属分类:" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择所属分类", allowClear: "" },
                      model: {
                        value: _vm.updateFrom.effectType,
                        callback: function ($$v) {
                          _vm.$set(_vm.updateFrom, "effectType", $$v)
                        },
                        expression: "updateFrom.effectType",
                      },
                    },
                    _vm._l(_vm.updateEffectTypeList, function (item) {
                      return _c(
                        "a-select-option",
                        {
                          key: item.effectType,
                          attrs: { value: item.effectType },
                        },
                        [_vm._v(" " + _vm._s(item.effectType) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "场景排序:" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入排序" },
                    model: {
                      value: _vm.updateFrom.sortNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "sortNumber", $$v)
                      },
                      expression: "updateFrom.sortNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "场景速度:" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择场景速度" },
                      model: {
                        value: _vm.updateFrom.effectOrder,
                        callback: function ($$v) {
                          _vm.$set(_vm.updateFrom, "effectOrder", $$v)
                        },
                        expression: "updateFrom.effectOrder",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "1" } }, [
                        _vm._v("标准"),
                      ]),
                      _c("a-select-option", { attrs: { value: "2" } }, [
                        _vm._v("慢"),
                      ]),
                      _c("a-select-option", { attrs: { value: "3" } }, [
                        _vm._v("快"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "场景版本:" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入场景版本", prefix: "Ver" },
                    model: {
                      value: _vm.updateFrom.sceneVersion,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "sceneVersion", $$v)
                      },
                      expression: "updateFrom.sceneVersion",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "光效应用版本:" } },
                [
                  _c("a-input", {
                    attrs: { placeholder: "请输入光效版本", prefix: "V" },
                    model: {
                      value: _vm.updateFrom.effectVersion,
                      callback: function ($$v) {
                        _vm.$set(_vm.updateFrom, "effectVersion", $$v)
                      },
                      expression: "updateFrom.effectVersion",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }